module.exports = __webpack_public_path__ + "img/visits-logo-active.c4d91b2f.svg";